module.exports = __webpack_public_path__ + "img/Rectangle 8.fe90bf38.png";